/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {registerProps as ɵa} from './confirm-dialog.props';